const debugOn = (process.env.REACT_APP_ENVIRONMENT === "Development" || process.env.REACT_APP_ENVIRONMENT === "Staging");


export const debugConsoleLog = (log: any): void => {
    if (debugOn) {
        console.log(log);
    }
}